import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckCircle2, Clock } from 'lucide-react';
const TYPE_LABELS = {
    proposal_due: 'Proposal Due',
    questions_due: 'Questions Due',
    opt_in: 'Opt-In',
    oral_presentation: 'Oral Presentation',
    site_visit: 'Site Visit',
    pre_proposal_conference: 'Pre-Proposal Conf',
    amendment_response: 'Amendment Response'
};
const TYPE_COLORS = {
    proposal_due: 'bg-rose-500',
    questions_due: 'bg-amber-500',
    opt_in: 'bg-blue-500',
    oral_presentation: 'bg-purple-500',
    site_visit: 'bg-emerald-500',
    pre_proposal_conference: 'bg-cyan-500',
    amendment_response: 'bg-slate-500'
};
/**
 * DeadlineTimeline — vertical timeline showing key dates in
 * chronological order with status indicators.
 */ export function DeadlineTimeline({ deadlines }) {
    if (deadlines.length === 0) return null;
    return /*#__PURE__*/ _jsxs("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "absolute left-[11px] top-2 bottom-2 w-px bg-slate-200"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "space-y-3",
                children: deadlines.map((d, i)=>{
                    const label = TYPE_LABELS[d.type] || d.type?.replace(/_/g, ' ');
                    const dotColor = TYPE_COLORS[d.type] || 'bg-slate-400';
                    const isPast = isDatePast(d.date);
                    const dateStr = [
                        d.date,
                        d.time,
                        d.timezone
                    ].filter(Boolean).join(' ');
                    return /*#__PURE__*/ _jsxs("div", {
                        className: "relative flex items-start gap-3 pl-0",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: `relative z-10 mt-1 h-[22px] w-[22px] flex-shrink-0 rounded-full border-2 border-white ${dotColor} flex items-center justify-center shadow-sm`,
                                children: isPast ? /*#__PURE__*/ _jsx(CheckCircle2, {
                                    className: "h-3 w-3 text-white"
                                }) : /*#__PURE__*/ _jsx(Clock, {
                                    className: "h-3 w-3 text-white"
                                })
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "min-w-0 flex-1 pb-1",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex items-baseline gap-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: `text-[13px] font-semibold ${isPast ? 'text-slate-400 line-through' : 'text-slate-800'}`,
                                                children: dateStr
                                            }),
                                            isPast && /*#__PURE__*/ _jsx("span", {
                                                className: "text-[10px] font-medium text-slate-400",
                                                children: "Passed"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "mt-0.5 text-[12px] text-slate-500",
                                        children: label
                                    })
                                ]
                            })
                        ]
                    }, `${d.type}-${i}`);
                })
            })
        ]
    });
}
function isDatePast(dateStr) {
    if (!dateStr) return false;
    try {
        const parsed = new Date(dateStr);
        if (Number.isNaN(parsed.getTime())) return false;
        return parsed.getTime() < Date.now();
    } catch  {
        return false;
    }
}
